export default [
  {
    path: 'district',
    name: 'district',
    component: () => import('@/views/pages/district/District.vue'),
    meta: {
      pageTitle: 'District',
      breadcrumb: [
        {
          text: 'District',
          active: true,
        },
      ],
      resource: 'All',
    },
  },
]
